import Axios from "axios";
export default class getProductType {
getProductType ( store, data ) {
    let that = store;
    let hostname = window.location.hostname;
    let params = new URLSearchParams();
    params.append('action', 'getproduct_type_and_family');
    params.append('STORE', store);
    params.append('PID', data.pid);
    Axios.post(
      "https://"+hostname+"/wp-admin/admin-ajax.php",
      params
    )
      .then(function (response) {
        try {
            that.tita = response.data.descrzione.tita;
            that.ten = response.data.descrizione.ten;
            that.fita = response.data.descrzione.fita;
            that.fen = response.data.descrizione.fen;
        } catch (error) {
            that.tita = 'NON DISPONIBILE';
            that.ten = 'NOT FOUND';
            that.fita = 'NON DISPONIBILE';
            that.fen = 'NON FOUND';
        }
      })
      .catch(function (error) {
        console.info(error);
      });

}

      
}
